import React, { useState } from "react";
import { connect } from "react-redux";
import { Table } from "reactstrap";
import { Translate } from "react-localize-redux";
import {
  addContactAction,
  deleteContactAction
} from "../../redux/actions/contacts.actions";
import ProfileCardModal from "../modals/ProfileCardModal";
import BasicSearchRow from "../BasicSearchRow";
import PropTypes from "prop-types";
import "./styles.scss";

const BasicSearchTable = ({
  addContactAction,
  contacts,
  deleteContactAction,
  searchResults,
  loggedIn,
  loggedInUser
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState();

  return (
    <React.Fragment>
      <Table borderless className="search-layout" size="sm">
        <thead id="table-headings">
          <tr>
            <th>
              <strong>
                <Translate id="nameText" />
              </strong>
            </th>
            <th>
              <strong>
                <Translate id="cityText" />
              </strong>
            </th>
            <th>
              <strong>
                <Translate id="numberText" />
              </strong>
            </th>
            <th />
          </tr>
        </thead>
        <tbody>
          {searchResults.map((searchItem, index) => (
            <BasicSearchRow
              rowItem={searchItem}
              key={`${searchItem.id}_${Math.random()}`}
              // contacts={contacts}
              onAdd={addContactAction}
              onRemove={deleteContactAction}
              loggedInUser={loggedInUser}
              isUserLoggedIn={loggedIn}
              contacts={loggedInUser.id === searchItem.id ? loggedInUser.contacts : searchItem.contacts}
              onRowClick={() => {
                setSelectedRow(index);
                setModalOpen(true);
              }}
            />
          ))}
        </tbody>
      </Table>
      <ProfileCardModal
        onToggle={() => {
          setModalOpen(!modalOpen);
        }}
        isOpen={modalOpen}
        profile={searchResults[selectedRow]}
        loggedInUser={loggedInUser}
        isUserLoggedIn={loggedIn}
        onAdd={addContactAction}
        onRemove={deleteContactAction}
        // contacts={contacts}
      />
    </React.Fragment>
  );
};

BasicSearchTable.propTypes = {
  searchResults: PropTypes.arrayOf(PropTypes.object)
};

const mapStateToProps = state => ({
  loggedInUser: state.profile.profile,
  contacts: state.profile.profile.contacts,
  searchResults: state.profile.searchResults,
  loggedIn: state.auth.loggedIn
});

export default connect(
  mapStateToProps,
  {
    addContactAction,
    deleteContactAction
  }
)(BasicSearchTable);



// WEBPACK FOOTER //
// ./src/components/BasicSearchTable/BasicSearchTable.jsx